import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router";
import PaymentModal from "../Modals/PaymentModal";
import {createOrder} from "../api/apis";
import SwishModal from "../Modals/SwishModal";
import { useApp } from "../Context";

export default function CheckoutPage() {
    const [cart, setCart] = useState([]);
    const [total, setTotal] = useState(0);
    const navigate = useNavigate();
    const VAT_RATE = 0.12; // 12% MOMS
    const [orderId, setOrderId] = useState(null);
    const [swish, setSwish] = useState(false)
    const [instructions, setInstructions] = useState("")
    const {getCfg, table} = useApp()

    const [payment, setPayment] = useState(null);


    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem("cart")) || { items: [], sum: 0 };
        setCart(storedCart.items);
        setTotal(storedCart.sum);
        setInstructions(storedCart.instructions || "")
    }, []);

    const vatAmount = total * VAT_RATE;
    const totalExclVAT = total - vatAmount;

    function handleOrder() {
        if(!orderId) {
            payWithSwish().then((response) => {
                setOrderId(response);
            })
        }
        setSwish(true)
    }

    return (
        <div className="px-1 mt-5">
            {/* Back Button */}
            <div className="d-flex align-items-center" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                <i className="bi bi-arrow-left-short fs-1"></i>
                <h5 className="mb-0">Tillbaka</h5>
            </div>

            <h2 className="text-center fw-bold text-dark mb-4">Kassa</h2>

            {cart.length === 0 ? (
                <p className="text-center text-muted">Din varukorg är tom.</p>
            ) : (
                <div className="row">
                    {/* Order Summary */}
                    <div className="">
                    <div className="card shadow-sm p-3">
    <h4 className="fw-bold text-dark">Orderöversikt</h4>
    <hr className="my-2"/>

    {cart.map((item, index) => (
        <div key={index} className="mb-2">
            {/* Main Item */}
            <div className="d-flex justify-content-between">
                <span className="fw-bold text-dark">{item.text.toSwe()}</span>
                <span className="fw-bold">{(item.price / 100).toFixed(2)} kr</span>
            </div>

            {/* Add-ons (if any) */}
            {item.customizations?.add_ons?.length > 0 && (
                <div className="mt-1" style={{ marginLeft: "15px" }}>
                    {item.customizations.add_ons.map((a, i) => (
                        <div key={i} className="d-flex justify-content-between">
                            <span className="text-muted"> {a.m0text.toSwe()}</span>
                            <span className="text-muted">{(a.m0pris / 100).toFixed(2)} kr</span>
                        </div>
                    ))}
                </div>
            )}

            {/* Side Orders (if any) */}
            {item.customizations?.sides?.length > 0 && (
                <div className="mt-1" style={{ marginLeft: "15px" }}>
                    {item.customizations.sides.map((s, i) => (
                        <div key={i} className="d-flex justify-content-between">
                            <span className="text-muted"> {s.m0text.toSwe()}</span>
                            <span className="text-muted">{(s.m0pris / 100).toFixed(2)} kr</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    ))}
    </div>
                    </div>

                    {/* Payment & Total Summary */}
                    <div className=" mt-2">
                        <div className="card shadow-sm p-3 bg-white">
                            <h5 className="fw-bold text-dark">Betalningsinformation</h5>
                            <div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Delsumma:</span>
                                    <span className="fw-bold">{totalExclVAT.toFixed(2)} kr</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">MOMS (12%):</span>
                                    <span className="fw-bold">{vatAmount.toFixed(2)} kr</span>
                                </div>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                                <span className="fw-bold fs-5">Totalt:</span>
                                <span className="fw-bold fs-5">{total.toFixed(2)} kr</span>
                            </div>

                            {/* Payment Options */}
                            <h5 className="fw-bold text-dark mt-3">Betalning</h5>

                            {/* Card Payment Button */}
                            {/* 
                            <button
                                className="btn btn-warning w-100 mb-2 fw-semibold d-flex align-items-center justify-content-center"
                                style={{ height: "50px" }}
                                onClick={() => setPayment("Card")}
                            >
                                <i className="bi bi-credit-card me-2"></i> Betala med Kort
                            </button>

                            <button
                                className="btn btn-dark w-100 mb-2 fw-semibold d-flex align-items-center justify-content-center p-1"
                                style={{ height: "50px" }}
                                onClick={() => setPayment("Google")}
                            >
                                <img
                                    src="https://developers.google.com/static/pay/api/images/brand-guidelines/google-pay-mark.png"
                                    alt="Google Pay"
                                    style={{ height: "100%", objectFit: "contain" }}
                                />
                            </button>
                            */}
                            {/* Swish Button */}
                            <button
                                className="btn w-100 fw-semibold d-flex align-items-center justify-content-center"
                                style={{
                                    height: "50px",
                                    border: "2px solid #45B128",
                                }}
                                onClick={handleOrder}
                            >
                                <img
                                    src="https://hjarnkraft.se/wp-content/uploads/2023/04/Swish-Logo-Secondary-Light-BG.png"
                                    alt="Swish"
                                    style={{ height: "90%", objectFit: "contain" }}
                                />
                            </button>
                        </div>
                        <PaymentModal method={payment} setMethod={setPayment} />
                        <SwishModal order={orderId} sum={total} show={swish} setShow={setSwish} />
                    </div>
                </div>
            )}
        </div>
    );

    async function payWithSwish() {
        let cfg = await getCfg();

        function gettxo(item){
            const txo = {}
            item.customizations?.add_ons.map((a)=>
                txo[a.m0lopnr] = a
            )

            return txo
        }

        function getsxo(item){
            const sxo = {}
            item.customizations?.sides.map((s)=>
                sxo[s.m0lopnr] = s
            )

            return sxo;
        }

        // Ensure `closed` is an integer

        // Add missing expected properties
        cfg.flow = "eatin";  // Default flow
        cfg.ftid = cfg.hours?.ftid || "1500"; // Default first time of the day
        cfg.ttid = cfg.hours?.ttid || "2300"; // Default last time of the day
        cfg.nocart = 1; // Assume 1 as per the given formatted example

        // Transform cart items
        const transformedCart = cart.map(item => ({
            gid: item.mnuid,
            plu: item.plu,
            text: item.text,
            antal: "1",
            pris: item.price,  // Keep price as is
            belopp: item.finalPrice.toString(),  // Ensure it's a string
            taxproc: "2000", // Assuming 20% VAT as an example
            pro: {
                plu: item.plu,
                text: item.text,
                price: item.price,
                desc: item.desc,
                belopp: item.finalPrice.toString(),
                m0fritxt: item.pbo.plu00.p0fritxt + item.customizations.removed.map(id=>{
                    const ingredient = item.pbo?.iga?.find(ing=> ing.p0lopnr === id);
                    return "\n-" + ingredient.p0text
                }),
                ino: {},
                ixo: {},
                txo: gettxo(item),
                sxo: getsxo(item),
                dxo: {}
            },
        }));

        // Construct `sbo`
        const sbo = {
            sio: null,
            cfg: cfg,
            unit: {},
            cdo: {
                msg: instructions || ""
            },
            cart: {
                bord: table,
                zone: "",
                belopp: (total * 100).toString(),
                rows: transformedCart,
                pro: {},
                levbelopp: "0",
                discount: "0",
                topay: (total * 100).toString(),
                slot: "1300"
            }
        };

        //console.log(sbo);

        // Trigger the Swish payment function
        //localStorage.setItem("sbo", JSON.stringify(sbo))
        //console.log(sbo)
        return await createOrder(sbo);
        //console.log("swish done");
        //console.log(respone)

                
                // Trigger the Swish payment functi
            }
    }
